export const ROUTE_PATHS = {
   HOME: '/',
   SIGNIN : '/signin',
   SIGNUP: '/signup',
   SIGNOUT: '/signout',
   VERIFY_OTP:'/verify-otp',
   AuthCallback:'/auth/callback',

   //Pages
   DASHBOARD:'/Overview',
   FOOTPRINT:'/footprint-tracker',
   AIINSIGHTS:'/ai-insights',
   SUPPLYCHAINFLOW:'/supply-chain-flow',
   PORTFOLIO:'/portfolio',
   INVESTMENTHUB:'/investment-hub',

   ABOUT:'/about',
   CONTACT:'/contact',
   FAQ:'/faq',

   //scmart
   AGRICULTURE:'projects/agriculture',
   FORESTRY:'projects/forestry',
   INDUSTRIAL_PROCESS:'projects/industrial-process',
   PLASTIC_ALTERNATIVES:'projects/plastic-alternatives',
   RENEWABLE_ENERGY:'projects/renewable-energy',
   WASTE_MANAGEMENT:'projects/waste-management',

   //Footer
   TermsAndConditions:'/terms-and-conditions',
   PrivacyPolicy:'/privacy-policy',

   //Invest
   INVEST:'invest',
   SCCredit:'/invest/sccredits',
   Transactions:'/invest/transactions',
   Retirements:'/invest/retirements',

   //Analysis
   ANALYSIS:'/analysis',
   Technical:'/analysis/technical',
   Reports:'/analysis/reports',
   News:'/analysis/news',

   //Platform
   MobileApp:'/platform/mobile',
   AnalysisPlatform:'/platform/analysis',
   Portfolio:'/platform/portfolio',

   // cookie Settings
   DataSecurity:'/datasecurity/data-security',
   CookiePolicy:'/datasecurity/cookie-policy',
   InformationSecurity:'/datasecurity/information-security',
}; 